import * as THREE from 'three';
import Delaunator from 'delaunator';
import {
  CARD1Web,
  MouseAction
} from '../CoordUtils.js';
import {
  Canvas2D,
  getVectorContainers
} from '@/js/util.js'
import { RoadModel } from "../models/RoadModel";
import { RoadStake } from "../models/RoadStake";
import { RoadUnit } from "../models/RoadUnit";
import { Navigator } from '@/drawings3D/navigation'
import { MedialDivider } from '@/drawings3D/models/MedialDivider'
import { MedialDividerDrawer } from '@/drawings3D/modelDrawing/MedialDividerDrawer'

export class EarthDrawer {
  constructor(roadData, demData, sceneManager) {
    this.roadData = roadData;
    this.sceneManager = sceneManager;
    var points = new Array();
    this.demData = demData;
    demData.map(item => {
      item.lon -= this.sceneManager.CoordOffset.lon;
      item.lat -= this.sceneManager.CoordOffset.lat;
    });
  }


  render() {
    var points = new Array();
    var earthVertices = [];
    this.demData.map(item => {
      var vertice = new THREE.Vector3(item.lat, item.h, item.lon);
      vertice.roadEdge = item.r;
      points.push([item.lon, item.lat, vertice]);
      earthVertices.push(vertice);
    });
    const delaunay = Delaunator.from(points);
   var vertices = [];
    var quadUvs = [];
    var indices = [];
    var normals = [];
    var counter = 0;
    this.helper = new CARD1Web.CoordUtils.Helper();
    for (let i = 0; i < delaunay.triangles.length; i += 3) {
    	//保证顺时针方向
    	var pt1 = earthVertices[delaunay.triangles[i]];
    	var pt2 = earthVertices[delaunay.triangles[i + 1]];
    	var pt3 = earthVertices[delaunay.triangles[i + 2]];
    	//通过道路中心线的点不画，算法有缺陷，三角网可能会跨道路或者漏
    	var r = false;
    	var l = false;
    	l = (pt1.roadEdge == "L" ||  pt2.roadEdge == "L" || pt3.roadEdge == "L");
    	r = (pt1.roadEdge == "R" ||  pt2.roadEdge == "R" || pt3.roadEdge == "R");
    	if (l && r){
    		continue;
    	}
    	indices.push(counter, counter + 1, counter + 2);
    	if(this.helper.leftOfLine(new THREE.Vector2(pt1.x, pt1.z), new THREE.Vector2(pt2.x, pt2.z), new THREE.Vector2(pt3.x, pt3.z))){
			
			vertices.push(pt2.x);
			vertices.push(pt2.y);
			vertices.push(pt2.z);
			quadUvs.push(0, 0);
			vertices.push(pt1.x);
			vertices.push(pt1.y);
			vertices.push(pt1.z);
			quadUvs.push(0, 1);
			vertices.push(pt3.x);
			vertices.push(pt3.y);
			vertices.push(pt3.z);
			quadUvs.push(1, 1);
			
			//faces.push(new THREE.Face3(delaunay.triangles[i + 1], delaunay.triangles[i], delaunay.triangles[i + 2], null, null, 1));
    	}
    	else{
    		vertices.push(pt1.x);
			vertices.push(pt1.y);
			vertices.push(pt1.z);
			quadUvs.push(0, 0);
			vertices.push(pt2.x);
			vertices.push(pt2.y);
			vertices.push(pt2.z);
			quadUvs.push(0, 1);
			vertices.push(pt3.x);
			vertices.push(pt3.y);
			vertices.push(pt3.z);
			quadUvs.push(1, 1);

    		//faces.push(new THREE.Face3(delaunay.triangles[i], delaunay.triangles[i + 1], delaunay.triangles[i + 2], null, null, 1));
    	}
    	counter += 3;
    	var normal = this.calcNormal(vertices); 
      	normals.push(normal.x, normal.y, normal.z); 
        normals.push(normal.x, normal.y, normal.z); 
        normals.push(normal.x, normal.y, normal.z);  

    }
    var earthTexture = new THREE.TextureLoader().load("/static/bimroad/textures/grass.jpg");

    var material = new THREE.MeshPhongMaterial({
      map: earthTexture
    });


    var frameMaterial = new THREE.MeshBasicMaterial({
      color: '#333333',
      wireframe: true
    });
    
    var earthGeometry = new THREE.BufferGeometry();
     earthGeometry.setIndex(indices);
    // earthGeometry.normalizeNormals();
    earthGeometry.addAttribute( 'normal', new THREE.Float32BufferAttribute( normals, 3 ) );
    earthGeometry.addAttribute('uv', new THREE.Float32BufferAttribute(quadUvs, 2));
    earthGeometry.addAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
    var earthMesh = new THREE.Mesh(earthGeometry, material);
    if (this.sceneManager.geometryManager.getMeshObject("earth")){
      this.sceneManager.geometryManager.removeMeshObject("earth");
    }
    this.sceneManager.geometryManager.addMeshObject("earth",earthMesh);
    this.sceneManager.geometryManager.addGroundObject(earthMesh);
  }

   calcNormal(vertices){
      var length = vertices.length;
      var a1 = new THREE.Vector3(vertices[length - 9], vertices[length - 8], vertices[length - 7]);
      var a2 = new THREE.Vector3(vertices[length - 6], vertices[length - 5], vertices[length - 4]);
      var a3 = new THREE.Vector3(vertices[length - 3], vertices[length - 2], vertices[length - 1]);
      a2.sub(a1).cross(a3.sub(a1));
      return a2.normalize();
  }

}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/EarthDrawer.js